import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function DataManagement() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Enterprise Data Management & Security</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Data Management & Security</div>
                                <h1 className="prod-hero-title">Enterprise <span>Data Management &amp; Security</span></h1>
                                <p>Protect enterprise data across multiple environments, meet privacy regulations and simplify operational complexity with comprehensive data security solutions.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg.png')} alt="Data Management" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">$4.45M</div>
                            <div className="prod-stat-label">Avg. Cost of a Data Breach</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">15%</div>
                            <div className="prod-stat-label">Breach Cost Rise in 3 Years</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">40%</div>
                            <div className="prod-stat-label">Breach Cost from Lost Business</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">24/7</div>
                            <div className="prod-stat-label">Continuous Data Monitoring</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* What is Data Security */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/data-management-1.jpg')} alt="Data Security" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Overview</div>
                                <h2>What is Data Security?</h2>
                                <p>Data security is the process of protecting corporate data and preventing data loss through unauthorized access. This includes protecting against ransomware, data corruption, modification, and ensuring data is available to authorized personnel.</p>
                                <p>Some industries require high-level data security to comply with regulations — organizations processing payment card information must follow PCI DSS standards, while healthcare organizations must comply with HIPAA.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '12px', display: 'inline-flex' }}>
                                    Learn More <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Types of Data Security */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Types</div>
                        <h2 className="prod-section-title">Types of <span>Data Security</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>A comprehensive data security strategy combines multiple layers of protection</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-lock"></i></div>
                            <h4>Encryption</h4>
                            <p>Using an algorithm to transform normal text into an unreadable format. File and database encryption solutions serve as a final line of defense — obscuring contents through encryption or tokenization.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-trash"></i></div>
                            <h4>Data Erasure</h4>
                            <p>More secure than standard data wiping, data erasure uses software to completely overwrite data on any storage device and verifies that the data is unrecoverable.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-eye-slash"></i></div>
                            <h4>Data Masking</h4>
                            <p>Allows teams to develop applications or train people using real data while masking personally identifiable information (PII) so development occurs in compliant environments.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-refresh"></i></div>
                            <h4>Data Resiliency</h4>
                            <p>Determined by how well an organization endures or recovers from any type of failure — hardware problems, power shortages, or other events. Speed of recovery is critical to minimize impact.</p>
                            <div className="prod-feature-number">04</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Data Security Tools */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Capabilities</div>
                        <h2 className="prod-section-title">Data Security <span>Capabilities &amp; Tools</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Comprehensive tools that address the growing challenges of securing complex, distributed, hybrid, and multicloud environments</p>
                    </div>
                    <div className="prod-numbered-list">
                        <div className="prod-step-item">
                            <span className="prod-step-num">01</span>
                            <div>
                                <h4>Data Discovery &amp; Classification Tools</h4>
                                <p>Sensitive information can reside in structured and unstructured repositories — databases, data warehouses, big data platforms, and cloud environments. These tools automate the process of identifying sensitive information and remediating vulnerabilities.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">02</span>
                            <div>
                                <h4>Data &amp; File Activity Monitoring</h4>
                                <p>Analyze data usage patterns, enabling security teams to see who is accessing data, spot anomalies, and identify risks. Dynamic blocking and alerting can be implemented for abnormal activity patterns.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">03</span>
                            <div>
                                <h4>Vulnerability Assessment &amp; Risk Analysis</h4>
                                <p>Detect and mitigate vulnerabilities such as out-of-date software, misconfigurations, or weak passwords. Identify data sources at greatest risk of exposure before attackers do.</p>
                            </div>
                        </div>
                        <div className="prod-step-item">
                            <span className="prod-step-num">04</span>
                            <div>
                                <h4>Automated Compliance Reporting</h4>
                                <p>Comprehensive data protection solutions with automated reporting capabilities provide a centralized repository for enterprise-wide compliance audit trails — simplifying regulatory adherence.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Benefits */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/technology/ai-benefit.jpg')} alt="Data Security Benefits" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Benefits</div>
                                <h2>Why Data Security Matters</h2>
                                <ul className="prod-benefits-list">
                                    <li><span className="ben-dot">✓</span>Discover data security vulnerabilities in real time</li>
                                    <li><span className="ben-dot">✓</span>Secure your data to prevent a catastrophic breach</li>
                                    <li><span className="ben-dot">✓</span>Help simplify regulatory compliance (GDPR, HIPAA, PCI DSS)</li>
                                    <li><span className="ben-dot">✓</span>Prevent unauthorized access to sensitive information</li>
                                    <li><span className="ben-dot">✓</span>Prevent data theft and insider threats</li>
                                </ul>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '24px', display: 'inline-flex' }}>
                                    Get Protected <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Data Security vs Privacy */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Understanding</div>
                        <h2 className="prod-section-title">Data Security <span>vs Data Privacy</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Two distinct but complementary disciplines that work together to protect your organization</p>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="prod-feature-card" style={{ height: '100%' }}>
                                <div className="prod-feature-icon"><i className="fa fa-user-secret"></i></div>
                                <h4>Access Control</h4>
                                <p>Ensuring that anyone who tries to access the data is authenticated to confirm their identity, and authorized to access only the data they are allowed to access — implementing role-based permissions and zero-trust principles.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-feature-card" style={{ height: '100%' }}>
                                <div className="prod-feature-icon"><i className="fa fa-shield"></i></div>
                                <h4>Data Protection</h4>
                                <p>Ensuring that even if unauthorized parties access the data, they cannot view or damage it. This includes encryption (preventing viewing without a private key) and data loss prevention (DLP) mechanisms to prevent sensitive data transfers outside the organization.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Secure Your Enterprise Data?</h3>
                            <p>Get a comprehensive data security assessment and customized protection strategy for your organization.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
